import { isEmpty } from "../lodash/isEmpty";

export function validateVehicle(vehicle: any) {
  return (!isEmpty(vehicle)
        && !isEmpty(vehicle.year)
        && !isEmpty(vehicle.make)
        && !isEmpty(vehicle.model));
}
